var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 5.25h2.63v2.63H5.25V14H2.62V7.87H0V5.25h2.63v-1.1c0-1.04.32-2.35.97-3.07A3.15 3.15 0 0 1 6.04 0h1.83v2.63H6.04a.79.79 0 0 0-.79.78v1.84Z"
  })));
};
export default SvgFacebook;